<template lang="pug">
v-menu(offset-y left nudge-bottom='14' min-width='230' content-class='user-profile-menu-content')

  template(#activator='{ on, attrs }')
    v-badge.ms-4(
      :color="user.logged ? 'success' : 'error'"
      offset-x="12" offset-y="12" overlap bottom dot
    )
      v-avatar(size='40px' v-bind='attrs' v-on='on')
        user-avatar(:user="user")

  v-list
    .pb-3.pt-2
      v-badge.ms-4(
        :color="user.logged ? 'success' : 'error'"
        offset-x="12" offset-y="12" overlap bottom dot
      )
        v-avatar(size='40px')
          user-avatar(:user="user")

      .d-inline-flex.flex-column.justify-center.ms-3(style='vertical-align:middle')
        span.text--primary.font-weight-semibold.mb-n1 {{ user.username }}
        small.text--disabled.text-capitalize.pr-4 {{ user.description }}

    v-divider

    //- Seleção de Ambiente
    v-list-item(
      :to="$to({ site: 'Home', eref: 'Home.Sitios' })"
    )
      v-list-item-icon.me-2
        v-icon(size='22') mdi-domain
      v-list-item-content
        v-list-item-title Seleção de Sítio

    //- System Configuration
    v-list-item(
      :to="$to({ site: 'Host', eref: 'Host.Workspace' })"
    )
      v-list-item-icon.me-2
        v-icon(size='22') mdi-leaf
      v-list-item-content
        v-list-item-title Configuração do Barramento

    //- Monitoramento
    template(v-if="monitor")
      v-list-item(
        @click="openMonitor"
      )
        v-list-item-icon.me-2
          v-icon(size='22') mdi-monitor-dashboard
        v-list-item-content
          v-list-item-title Monitoramento do Barramento

    v-divider

    //- // Profile
    //- v-list-item(link)
    //-   v-list-item-icon.me-2
    //-     v-icon(size='22')
    //-       | {{ icons.mdiAccountOutline }}
    //-   v-list-item-content
    //-     v-list-item-title Profile
    //- // Email
    //- v-list-item(link)
    //-   v-list-item-icon.me-2
    //-     v-icon(size='22')
    //-       | {{ icons.mdiEmailOutline }}
    //-   v-list-item-content
    //-     v-list-item-title Inbox
    //- // Chat
    //- v-list-item(link)
    //-   v-list-item-icon.me-2
    //-     v-icon(size='22')
    //-       | {{ icons.mdiChatOutline }}
    //-   v-list-item-content
    //-     v-list-item-title Chat
    //-   v-list-item-action
    //-     v-badge(inline color='error' content='2')
    //- v-divider.my-2
    //- // Settings
    //- v-list-item(link)
    //-   v-list-item-icon.me-2
    //-     v-icon(size='22')
    //-       | {{ icons.mdiCogOutline }}
    //-   v-list-item-content
    //-     v-list-item-title Settings
    //- // Pricing
    //- v-list-item(link)
    //-   v-list-item-icon.me-2
    //-     v-icon(size='22')
    //-       | {{ icons.mdiCurrencyUsd }}
    //-   v-list-item-content
    //-     v-list-item-title Pricing
    //- // FAQ
    //- v-list-item(link)
    //-   v-list-item-icon.me-2
    //-     v-icon(size='22')
    //-       | {{ icons.mdiHelpCircleOutline }}
    //-   v-list-item-content
    //-     v-list-item-title FAQ
    //- v-divider.my-2
    //- Logout
    //- v-list-item(link)
    //-   v-list-item-icon.me-2
    //-     v-icon(size='22')
    //-       | {{ icons.mdiLogoutVariant }}
    //-   v-list-item-content
    //-     v-list-item-title Logout

    //- Login
    v-list-item(
      v-if="!user.logged"
      link
      @click="login"
    )
      v-list-item-icon.me-2
        v-icon(size='22')
          | {{ icons.mdiLoginVariant }}
      v-list-item-content
        v-list-item-title Login

    //- Logout
    v-list-item(
      v-if="user.logged"
      link
      @click="logout"
    )
      v-list-item-icon.me-2
        v-icon(size='22')
          | {{ icons.mdiLogoutVariant }}
      v-list-item-content
        v-list-item-title Logout

</template>

<script>
import {
  SYSTEM,
  IDENTITY,
  STORE_IDENTITY,
  DISCARD_ALL_ENTITIES,
 } from '@/store/mutation-types'
import { mapState } from 'vuex'
import UserAvatar from '@/layouts/components/user-features/UserAvatar'
import {
  mdiAccount,
  mdiAccountOutline,
  mdiEmailOutline,
  mdiCheckboxMarkedOutline,
  mdiChatOutline,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiHelpCircleOutline,
  mdiLogoutVariant,
  mdiLoginVariant,
  mdiCog,
} from '@mdi/js'

export default {
  components: {
    UserAvatar
  },

  data: () => ({
    icons: {
      mdiAccountOutline,
      mdiEmailOutline,
      mdiCheckboxMarkedOutline,
      mdiChatOutline,
      mdiCogOutline,
      mdiCurrencyUsd,
      mdiHelpCircleOutline,
      mdiLogoutVariant,
      mdiLoginVariant,
      mdiCog,
      mdiAccount,
    },
  }),

  computed: {
    ...mapState({
      identity (state) {
        return state[SYSTEM][IDENTITY]
      },
    }),

    user () {
      const identity = this.identity || {}
      const logged = !!this.identity
      const login = logged ? identity.name : 'anonymous'
      const username = logged ? identity.givenName || identity.name : 'Anônimo'
      const description  = logged ? identity.role : 'Usuário não autenticado.'
      const claims = this.identity?.claims || {}
      return { logged, login, username, description, claims }
    },

    monitor () {
      return `http://${window.location.hostname}:5341/`
    },
  },

  methods: {
    login () {
      this.$browse({ eref: 'Index.Login' })
    },

    logout () {
      this.$store.commit(STORE_IDENTITY, null)
      this.$store.commit(DISCARD_ALL_ENTITIES)
      this.$browse({ eref: 'Index.Login' })
    },

    openMonitor () {
      // Abrir o site de monitoramento em uma nova aba
      window.open(this.monitor, { target: this.monitor })
    }
  },
}
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
</style>
